import type { VariableIconName } from './types';

/**
 * The category's colour, worn by its heading glyph and by every row icon under
 * it — so a long picker is scannable by hue before it is readable by word.
 *
 * Semantic scale tokens, not chart tokens, with two exceptions. The chart
 * palette is the only place this design system has a violet (`chart-4`), and
 * by the time Organization needed a colour every semantic scale was taken but
 * `error`, which would read as destructive — hence `chart-6`'s warm orange.
 * Chart tokens resolve to the same value in both themes (see `--chart-4` /
 * `--chart-6` in `index.css`), which is why they alone need no `dark:` pair.
 *
 * Lives apart from `variable-icons.tsx` because that file exports components,
 * and mixing constants in breaks fast refresh for the whole module.
 */
const TINTS: Record<VariableIconName, string> = {
    contact: 'text-primary-600 dark:text-primary-400',
    organization: 'text-chart-6',
    custom: 'text-success-600 dark:text-success-400',
    trigger: 'text-warning-600 dark:text-warning-400',
    step: 'text-info-600 dark:text-info-400',
    ai: 'text-chart-4',
    extracted: 'text-chart-4',
    variable: 'text-text-tertiary',
};

/** Tailwind text colour for a category. */
export function variableTint(name?: VariableIconName): string {
    return TINTS[name ?? 'variable'];
}
